import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { Permalink } from '@/models/permalinkSchema';
import { ONE } from '@/constants/common';
import { PermalinksState } from './permalinks.types';
import { createPermalink, getPermalinks, updatePermalink } from './permalinks.thunks';

export const getPermalinksReducer = (builder: ActionReducerMapBuilder<PermalinksState>): void => {
  builder.addCase(getPermalinks.pending, state => {
    state.list.loading = 'pending';
  });
  builder.addCase(getPermalinks.fulfilled, (state, action) => {
    state.list.data = action.payload;
    state.list.loading = 'succeeded';
  });
  builder.addCase(getPermalinks.rejected, state => {
    state.list.loading = 'failed';
  });
};

export const createPermalinkReducer = (builder: ActionReducerMapBuilder<PermalinksState>): void => {
  builder.addCase(createPermalink.fulfilled, (state, action) => {
    (state.list.data as Permalink[]).push(action.payload);
  });
};

export const updatePermalinkReducer = (builder: ActionReducerMapBuilder<PermalinksState>): void => {
  builder.addCase(updatePermalink.fulfilled, (state, action) => {
    const updated = action.payload;
    const list = state.list.data as Permalink[];
    const index = list.findIndex(p => p.id === updated.id);
    if (index !== -ONE) {
      list[index] = updated;
    }
  });
};
